const base = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:5000";
export const API = `${base}/api/v1/website`;
